import { FC } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@app/shared/ui/dialog';
import { Button } from '@app/shared/ui/button';
import { TrashIcon } from '@app/components/ui/icons';
import { cvaIcon } from '@app/shared/ui/elements';

type DeleteModalProps = {
  deleteElement: () => void;
  close: () => void;
  deleteType: 'slide' | 'presentation';
  isOpen: boolean;
};

const DeleteModal: FC<DeleteModalProps> = (props) => {
  const { deleteElement, close, deleteType = 'presentation', isOpen } = props;

  const onClickDelete = () => {
    deleteElement();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && close()}>
      <DialogContent className="max-w-[26rem] bg-general_background_MIII_450_dark p-8 text-center">
        <div className="flex flex-col items-center gap-4">
          <div className="flex items-center justify-center gap-3">
            <TrashIcon className={cvaIcon({ size: 'large' })} />
            <DialogTitle className="text-font_ds_title_title_title_20 font-semibold text-general_text_MII_default">
              Delete this {deleteType}?
            </DialogTitle>
          </div>

          <DialogDescription className="text-general_text_MII_secondary_i">
            It will not be possible to restore it, but you can create a new one
          </DialogDescription>

          <div className="flex w-full flex-col gap-4 mt-2">
            <Button variant="outline" size="medium" isFullWidth onClick={onClickDelete}>
              Yes, delete
            </Button>

            <Button variant="primary" size="medium" isFullWidth onClick={close}>
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
